import React, { useEffect, useState } from 'react';

//components
import { IconLibrary, ThriveIcon } from '../../..';
import NumberAnimation from "../../information/numbers/NumberAnimation";

//interfaces
import { IBasicSocialButtonPanel } from '../../../../interfaces/buttons/ButtonPanels';


const BasicSocialButtonsPanel = ({
    panelClassName,
    contentId,
    likingEnabled = false,
    commentingEnabled = false,
    totalLikes = 0,
    totalComments = 0,
    userLiked = false,
    onLikeClick,
    onCommentClick,
}: IBasicSocialButtonPanel) => {

    const [liked, setLiked] = useState<boolean>(userLiked);
    const [displayLikes, setDisplayLikes] = useState<number>(totalLikes ?? 0);

    useEffect(() => {
        setLiked(userLiked);
    }, [userLiked]);

    useEffect(() => {
        setDisplayLikes(totalLikes ?? 0);
    }, [totalLikes]);

    const handleLikeClick = () => {
        setLiked(prevLiked => {
            const isIncreasing = !prevLiked;

            setDisplayLikes(prevCount =>
                prevCount + (isIncreasing ? 1 : -1)
            );

            return !prevLiked;
        });

        onLikeClick?.();
    };

    return (
        <div key={`${contentId}-social-bar`} className={`basic-social-button-panel-wrapper ${panelClassName ?? ""}`}>
            {likingEnabled &&
                <button
                    className={`social-button-panel-button ${liked ? "active-social-button" : "in-active-social-button"}`}
                    aria-label={liked ? "Liked content" : "Like content"}
                    onClick={handleLikeClick}
                    type="button"
                >
                    <ThriveIcon
                        className="button-panel-like-icon"
                        iconName={IconLibrary.LIKE}
                        color="var(--thriveWhite)"
                        sizeInPx="16"
                    />
                    
                    <NumberAnimation
                        value={displayLikes}
                    />
                </button>
            }

            {commentingEnabled &&
                <button
                    className={`social-button-panel-button in-active-social-button`}
                    aria-label="Add comment to content"
                    onClick={onCommentClick}
                    type="button"
                >
                    <ThriveIcon
                        className="button-panel-comment-icon"
                        iconName={IconLibrary.COMMENT}
                        color="var(--thriveCharcoal)"
                        sizeInPx="16"
                    />

                    <span className="total-comments-span">{totalComments}</span>
                </button>
            }
        </div>
    );
};

export default BasicSocialButtonsPanel;